<div #scrollMe style="margin-left: -2%;margin-top: -2%;">
<div class="card card-border doNotPrint">
  <div class="card-body">
    <div class="row">
      <div class="col-md-1 col-lg-1">
      </div>
      <div class=" col col-xs-4  col-sm-4 col-md-4 col-lg-4">
        <p class="h8 align-serach-results-label"><b>Search Results</b></p>
        <p class="h8 italic align-sub-label">(grouped by generic name)</p>
      </div>
    </div>

      <div *ngIf="searchByDrugNameMap == undefined || searchByDrugNameMap.size === 0">
        <div class="alert alert-danger alert-dismissible">
          <span>{{noSearchResultsFound}}</span>
        </div>
      </div>

    <ul  id="myUL" *ngFor="let recipient of searchByDrugNameMap | keyvalue;let i=index" style="padding-bottom: 1%;">
      <li class="generic-label-color">
        <mat-icon *ngIf="arrowFlag" class="default-color arrowStyle" aria-hidden="false" aria-label="Example home icon"   (click)="expandTreeLeaf(true,i)">keyboard_arrow_right</mat-icon>
        <mat-icon *ngIf="!arrowFlag" class="default-color arrowStyle" aria-hidden="false" aria-label="Example home icon"    (click)="expandTreeLeaf(false,i)">keyboard_arrow_down</mat-icon>
        <!-- <i class="fa fa-angle-right fa-lg default-color"  id="{{ 'brand-'+i }}" (click)="expandTreeLeaf(i)" aria-hidden="true"></i>-->
          <span class="h8 italic align-generic-label" *ngIf="planDetails?.drugSearchType !== 'searchByDrugClass'">{{recipient.key|lowercase}}</span><span class="h8  align-generic-label" *ngIf="planDetails?.drugSearchType === 'searchByDrugClass'"><b>{{recipient.key}}</b></span>
        <ul id="{{ 'label-'+i }}" class="nested align-tree-li" >
          <li *ngFor="let recipientValue of recipient.value;let j=index" style="padding-bottom: 1%;">
            <input aria-label="State" *ngIf="planDetails?.drugSearchType != 'searchByDrugClass'" class="form-check-input" type="radio" name="radioNoLabel" id="{{ 'radioLabel-'+j}}" value="" (change)="getCoverageDetails(recipientValue.labelName)"><span *ngIf="planDetails?.drugSearchType != 'searchByDrugClass'"><span class="h8" *ngIf="recipientValue.gpiCode === '2'"><b>{{recipientValue.labelName}}</b></span><span class="h8" *ngIf="recipientValue.gpiCode !== '2'"><i>{{recipientValue.labelName | lowercase}}</i></span></span>
            <input aria-label="State" *ngIf="planDetails?.drugSearchType === 'searchByDrugClass'" class="form-check-input" type="radio" name="radioNoLabel" id="{{ 'radioLabel-'+j}}" value="" (change)="getDrugSearchDetailData1(recipientValue)"><span *ngIf="planDetails?.drugSearchType === 'searchByDrugClass'"><span class="h8" *ngIf="recipientValue.gpiCode === '2'"><b>{{recipientValue.labelName}}</b></span><span class="h8" *ngIf="recipientValue.gpiCode !== '2'"><i>{{recipientValue.labelName | lowercase}}</i></span></span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>

<br>
<div>
  <div class="card card-border" #printErrorComp *ngIf="showError">
    <div class="card-body">
      <div>
        <div class="alert alert-danger alert-dismissible">
          <span *ngIf="planDetails?.urlDrugNotFoundMessage === 'NC'">{{drugNotCovered}}</span>
          <span *ngIf="planDetails?.urlDrugNotFoundMessage === 'EX'">{{drugExcluded}}</span>
          <span *ngIf="planDetails?.urlDrugNotFoundMessage === 'NF'">{{drugNonFormulary}}</span>
          <span *ngIf="planDetails?.urlDrugNotFoundMessage === 'NR'">{{noResultsFound}}</span>
        </div>
      </div>
    </div>

    <div class="row align-alternative" *ngIf="displayAlternativesButton && planDetails?.drugSearchType != 'searchByDrugClass'">
      <div class=" col col-xs-12  col-sm-12 col-md-12 col-lg-12 doNotPrint">
        <button type="button" class="btn btn-primary"  (click)="showAlternatives('btnEvent')">Show Formulary Alternatives</button>
      </div>
    </div>
    <br>
  </div>
</div>
<div #drugSearch>
  <div *ngIf="drugSearchDetailDataList.length>0">
    <div *ngIf="drugSearchDetailDataList.length>1" style="margin-left: 2%;"><h6><b>Note : {{drugSearchDetailDataList.length}} records found</b></h6></div>
    <app-drug-search-details *ngFor="let drugSearchDetail of drugSearchDetailDataList;let i =index" [pIndex] = "i" [drugSearchDetail] ="drugSearchDetail" [searchByDrugNameMap]=searchByDrugNameMap [isBrandOrGeneric] = isBrandOrGeneric></app-drug-search-details>
  </div>
</div>
</div>


<ng-template #alternativesmodal let-modal class="doNotPrint">
  <br>
  <div class="row">
    <div class = "col col-xs-4  col-sm-4 col-md-4 col-lg-4">
    </div>
    <div class = "col col-xs-5  col-sm-5 col-md-5 col-lg-5">
      <p class="h4"><b>Formulary Alternatives</b></p>
    </div>
    <div class = "col col-xs-2  col-sm-2 col-md-2 col-lg-2">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>
  <div *ngIf="!showError">
  </div>
  <div class="card card-border">
  <div class="modal-body" (scroll)="scrollHandler($event)">
    <div class="alert alert-danger alert-dismissible" *ngIf="alternativeErrorMessage">
      <span>{{noAlternativesMessage}}</span>
    </div>
    <table class="table table-striped table-hover">
      <tr *ngFor="let drugSearchAlternative of validMatchingEntryList">
        <td style="width:40%">
          <span *ngIf="drugSearchAlternative.gpiCode === '2'" class="alternative-styling" (click)="modal.close('Save click');doCallBackFromAlternatives(drugSearchAlternative)">{{drugSearchAlternative.labelName | uppercase}}</span>
          <span *ngIf="drugSearchAlternative.gpiCode !== '2'" class="alternative-styling italic" (click)="modal.close('Save click');doCallBackFromAlternatives(drugSearchAlternative)">{{drugSearchAlternative.labelName | lowercase}}</span>
        </td>
        <td style="width:10%">
          <span> Tier {{drugSearchAlternative.tierValueCount}}</span>
        </td>
        <td style="width:50%" >
            <span> {{ drugSearchAlternative.programParticipation }}</span>
        </td>
      </tr>
    </table>
  </div>
  </div>
</ng-template>

